import React from "react";
import numberWithCommas from "../common/number";
import FontAwesome from "react-fontawesome";

const RederAccountlist = ({
  lastBookElementRef,
  list,
  reportcode,
  handleOnClick,
}) => {
  if (!reportcode) {
    return;
  }
  // console.log(list);
  return (
    <>
      {list &&
        list.map((item, index) => {
          if (list.length === index + 1) {
            return (
              <div className="row" key={item.no}>
                  <div className="card border-secondary m-1">
                    <div className="card-body">
                      <div ref={lastBookElementRef} className="row">
                        <div className="col-xs-12 col-sm-4">
                          <div
                            className="border-bottom"
                            style={{ fontSize: "15px" }}
                          >
                            <span className="badge rounded-pill bg-secondary">
                              {item.no}
                            </span>
                          </div>
                          <div
                            className="border-bottom"
                            style={{ fontSize: "13px" }}
                          >
                            {"วันที่:"} {item.dateout}
                          </div>
                          {reportcode === "03" ? (
                            <div
                              className="border-bottom"
                              style={{ fontSize: "13px" }}
                            >
                              {"ลูกค้า:"} {item.name}
                            </div>
                          ) : (
                            <div
                              className="border-bottom"
                              style={{ fontSize: "13px" }}
                            >
                              {"สินค้า:"} {item.name}
                            </div>
                          )}
                        </div>

                        <div className="col-xs-12 col-sm-4">
                          {reportcode === "04" ? (
                            <div
                              className="border-bottom"
                              style={{ fontSize: "14px" }}
                            >
                              {"lot:"} {item.lot}
                            </div>
                          ) : (
                            <div
                              className="border-bottom"
                              style={{ fontSize: "14px" }}
                            >
                              {"วัตถุประสงค์:"} {item.ordername}
                            </div>
                          )}
                          <div
                            className="border-bottom"
                            style={{ fontSize: "14px" }}
                          >
                            {"แหล่งที่มา:"} {item.source}
                            <div className="col-sm-6 my-1"></div>
                          </div>
                          <div
                            className="border-bottom"
                            style={{ fontSize: "14px" }}
                          >
                            {"สถานที่ลง:"} {item.store}
                            <div className="col-sm-6 my-1"></div>
                          </div>
                        </div>

                        <div className="container col-xs-12 col-sm-4">
                          <div
                            className="border-bottom"
                            style={{ fontSize: "14px" }}
                          >
                            <span
                              className="badge rounded-pill bg-warning text-dark"
                              style={{ fontSize: "13px" }}
                            >
                              {numberWithCommas(item.weighttotal)}
                            </span>
                            {" ตัน"}
                          </div>
                          <div
                            className="border-bottom"
                            style={{ fontSize: "14px" }}
                          >
                            <span
                              className="badge rounded-pill bg-success"
                              style={{ fontSize: "13px" }}
                            >
                              {item.amount}
                            </span>
                            {" เที่ยว"}
                            <div className="col-sm-6 my-1"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
           
              </div>
            );
          } else {
            return (
              <div className="row" key={item.no}>
           
                  <div className="card p-0">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-xs-12 col-sm-4">
                          <div
                            className="border-bottom"
                            style={{ fontSize: "15px" }}
                          >
                            <span className="badge rounded-pill bg-secondary">
                              {item.no}
                            </span>
                          </div>
                          <div
                            className="border-bottom"
                            style={{ fontSize: "13px" }}
                          >
                            {"วันที่:"} {item.dateout}
                          </div>
                          {reportcode === "03" ? (
                            <div
                              className="border-bottom"
                              style={{ fontSize: "13px" }}
                            >
                              {"ลูกค้า:"} {item.name}
                            </div>
                          ) : (
                            <div
                              className="border-bottom"
                              style={{ fontSize: "13px" }}
                            >
                              {"สินค้า:"} {item.name}
                            </div>
                          )}
                        </div>

                        <div className=" col-xs-12 col-sm-4">
                          {reportcode === "04" ? (
                            <div
                              className="border-bottom"
                              style={{ fontSize: "14px" }}
                            >
                              {"lot:"} {item.lot}
                            </div>
                          ) : (
                            <div
                              className="border-bottom"
                              style={{ fontSize: "14px" }}
                            >
                              {"วัตถุประสงค์:"} {item.ordername}
                            </div>
                          )}

                          <div
                            className="border-bottom"
                            style={{ fontSize: "14px" }}
                          >
                            {"แหล่งที่มา:"} {item.source}
                            <div className="col-sm-6 my-1"></div>
                          </div>
                          <div
                            className="border-bottom"
                            style={{ fontSize: "14px" }}
                          >
                            {"สถานที่ลง:"} {item.store}
                            <div className="col-sm-6 my-1"></div>
                          </div>
                        </div>

                        <div className="col-xs-12 col-sm-4">
                          <div
                            className="border-bottom"
                            style={{ fontSize: "14px" }}
                          >
                            <span
                              className="badge rounded-pill bg-warning text-dark"
                              style={{ fontSize: "13px" }}
                            >
                              {numberWithCommas(item.weighttotal)}
                            </span>{" "}
                            {" ตัน"}
                          </div>
                          <div
                            className="border-bottom"
                            style={{ fontSize: "14px" }}
                          >
                            <span
                              className="badge rounded-pill bg-success"
                              style={{ fontSize: "13px" }}
                            >
                              {item.amount}
                            </span>
                            {" เที่ยว"}
                            <div className="col-sm-6 my-1"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            );
          }
        })}
    </>
  );
};

export default RederAccountlist;
